<template>
    <div class="goods" v-track:exposure :track-params="JSON.stringify({event: 114, skuId: goods.skuId, skuName: goods.skuName})">
        <Head
            v-if="!showN"
            :headInfo='headInfo'
            @onClickLeft='onBack'
        />
        <div v-show="presellShow">
            <BannerSwiper :pageWidth='pageWidth' :imgUrlList='goods.imgUrlList'></BannerSwiper>
            <NavTitle
                :goods='goods'
                :timeHtml='timeHtml'
                :timeDown='timeDown'
                @onCount='onCount'
                @onShareGoods='onShareGoods'
            />
            <div class="mark arrow2 mtop20 borderBot borderBotLeft0 col999" @click="onPen(1)">
                <img src="../../../assets/img/b2b/icon_zheng@2x.png" alt="">正品保障&店铺售后<div class="item"></div>
            </div>
            <div class="mtop20">
                <ShopName :shopName='shopName' />
            </div>
            <div class="mtop20 mark borderBotLeft0 col999" v-show="goods.inventoryOriginNum > goods.inventoryRemainNum">
                已预定{{ goods.inventoryOriginNum - goods.inventoryRemainNum }}件
                <div class="item">
                    <van-notice-bar left-icon="" background='#ffffff' color="#333333" :scrollable="false">
                        <van-swipe
                            vertical
                            class="notice-swipe"
                            :autoplay="3000"
                            :show-indicators="false"
                        >
                            <van-swipe-item v-for="(item, index) in sliderData" :key="index">{{ subTel(item.mobile) }}预定{{ item.quantity }}件</van-swipe-item>
                        </van-swipe>
                    </van-notice-bar>
                </div>
            </div>
            <div class="contentDetail mtop20">
                <van-tabs v-model="active" titleActiveColor='#ff7a45' line-height='0px'>
                    <van-tab :title="headerCenter" >
                        <div class="demo-item textCenter" v-html="detail"></div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="foot" v-if="$isApproveShow()">
                <div class="btn" :class="{'active': isStart || !goods.inventoryRemainNum || goods.presaleStatus == 3}" @click="onPen(2)">{{ fotName() }}</div>
            </div>
            <div class="foot" v-else>
                <div class="btn" @click="onPen(3)">认证后可购买</div>
            </div>
        </div>
        <van-popup v-model="popupVisible2" position="bottom" :closeOnClickModal='false'>
            <div class="select">
                <div class="head borderBot borderBotLeft0">
                    <div class="img">
                        <img :src="picUrl" alt="">
                    </div>
                    <div class="title2">
                        <div class="close">
                            <img @click="onClose()" src="../../../assets/img/b2b/btn_delete@2x.png" alt="">
                        </div>
                        <div class="goodsBt">
                            <div class="price">
                                定金：<sub>¥ </sub>{{ goods.reserveAmount | NumFormat }}
                            </div>
                            <div class="cont" v-if="goods.skuCode">
                                商品编号：{{ goods.skuCode }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nums">
                    <div class="name">购买数量</div>
                    <div class="cartN">
                        <div class="xg">限购{{ goods.purchaseLimitNum }}件</div>
                        <div class="cartClass">
                            <van-stepper v-model="goods.quantity" :max='goods.inventoryRemainNum > goods.purchaseLimitNum ? goods.purchaseLimitNum : goods.inventoryRemainNum' />
                        </div>
                    </div>
                </div>
            </div>
            <div class="lines"></div>
            <div class="fot">
                <div class="btn">
                    <div class="btn1 btnRed" @click="onBuy()">立即购买</div>
                </div>
            </div>
        </van-popup>
        <Server :visible.sync='popupVisible'></Server>
        <CustomerService :goodInfo='goodInfo' />
        <van-overlay :show="showN" class-name='overlayClass' :lock-scroll='false' @click="onOverlay" />
        <van-overlay :show="showNew" @touchmove.prevent :z-index=10000 @click="showNew = false">
            <div class="wrapper" >
                <div class="overblock">
                    <img src="../../../assets/img/b2b/sharePic.png" alt="">
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Head from '../../common/head'
import { Toast } from 'vant'
import { versions } from '../../common/version'
import { getInvitationCode, shopInfo } from '../api/api'
import { getPresellGoodDetail } from '../api/activity'
import { presellSlider } from '../api/order'
import BannerSwiper from '../common/detail/bannerSwiper' // banner详情
import NavTitle from '../common/detail/navTitle'
import CustomerService from '../common/customerService'
import Server from '../common/detail/server' // 服务协议
import ShopName from '../common/shopNameTemplate' // 小店
export default {
    name: 'presellActivityGoodDetail',
    components: {
        Head,
        BannerSwiper,
        NavTitle,
        Server,
        CustomerService,
        ShopName
    },
    data () {
        return {
            headInfo: {
                title: '商品详情'
            },
            active: 1,
            headerCenter: '商品介绍',
            presaleId: this.$route.query.presaleId,
            skuId: this.$route.query.skuId,
            showN: false,
            showNew: false,
            goods: {},
            shopName: '',
            detail: '',
            popupVisible: false,
            popupVisible2: false,
            sku: {},
            picUrl: '',
            isStart: true,
            pageWidth: document.documentElement.clientWidth,
            timeDown: 0,
            timeHtml: '距离结束',
            userInfo: '',
            invitationCode: '',
            totalNum: 0,
            sliderData: [],
            goodInfo: null,
            presellShow: false
        }
    },
    methods: {
        onBack () {
            if (!this.$route.query.isShare) {
                if (this.goodsDetailBack) {
                    localStorage.removeItem('activityData')
                    this.$router.push({ path: this.goodsDetailBack })
                } else {
                    this.$router.go(-1)
                }
            } else {
                if (this.goodsDetailBack) {
                    this.$router.push({ path: this.goodsDetailBack })
                } else {
                    this.$router.push({ path: '/b2b/home/index' })
                }
            }
        },
        onCount () {
            this.isStart = false
        },
        onOverlay () {
            this.showNew = true
        },
        subTel (tel) {
            return tel.replace(tel.substring(3, 9), '******')
        },
        NumFormat (val) {
            if (val === '' || val == null) {
                return val
            }
            let value = Number(val).toFixed(2)
            let s = value.toString().indexOf('.')
            if (s === -1) {
                return (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
            } else {
                let arr = value.toString().split('.')
                return (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1]
            }
        },
        fotName () {
            if (this.goods.presaleStatus === 3) {
                return '活动已结束'
            } else if (!this.goods.inventoryRemainNum) {
                return '已预定完'
            } else {
                return '立即付定金 ¥' + this.NumFormat(this.goods.reserveAmount)
            }
        },
        onPen (val) {
            switch (val) {
                case 1:
                    this.popupVisible = true
                    break
                case 2:
                    if (!this.goods.hasPurchaseRight) {
                        Toast('您没有权限购买此商品')
                        return false
                    }
                    if (this.isStart || !this.goods.inventoryRemainNum) {
                        return false
                    }
                    this.popupVisible2 = true
                    break
                case 3:
                    this.$router.push({ path: '/b2b/company/index' })
                    break
                default:
                    break
            }
        },
        onBuy () {
            this.popupVisible2 = false
            this.popupVisible = false
            let skuList = [{
                merchantCode: this.goods.merchantCode,
                presaleId: this.presaleId,
                skus: [
                    {
                        skuId: this.skuId,
                        quantity: this.goods.quantity
                    }
                ]
            }]
            localStorage.setItem('goodsData', JSON.stringify(skuList))
            this.$router.push({ path: '/b2b/order/confirmOrder', query: { presaleId: this.presaleId } })
            // localStorage.setItem('type', 1)
            // localStorage.removeItem('invoiceList')
            // localStorage.removeItem('addressList')
            // localStorage.removeItem('addressInfo')
            // localStorage.removeItem('effectData')
            // localStorage.removeItem('pricList')
            // localStorage.setItem('goodsId', this.skuId)
            // localStorage.setItem('presaleId', this.presaleId)
            // localStorage.setItem('goodsData', JSON.stringify([{ 'skuId': this.skuId, 'quantity': this.goods.quantity }]))
            // localStorage.setItem('confirmOrderBack', this.$router.history.current.fullPath)
            // localStorage.setItem('selectAddressBack', this.$router.history.current.fullPath)
            // localStorage.setItem('addressId', 2)
            // this.$router.push({ path: '/b2b/companyActivity/confirmOrder' })
            // this.$router.push({
            //     name: 'activityOrder',
            //     params: {
            //         presaleId: this.presaleId
            //     }
            // })
        },
        onClose () {
            this.popupVisible = false
            this.popupVisible2 = false
        },
        timeString () {
            let nowtime = this.getTimeString(this.goods.nowTime)
            let startTime = this.getTimeString(this.goods.startTime)
            let endTime = this.getTimeString(this.goods.endTime)
            this.isStart = startTime < nowtime
            if (nowtime > startTime) {
                this.timeHtml = '距离结束'
                this.timeDown = endTime - nowtime
                this.isStart = false
            } else {
                this.timeHtml = '距离开始'
                this.timeDown = startTime - nowtime
                this.isStart = true
            }
        },
        getTimeString (data) {
            return new Date(data).getTime()
        },
        async getGoodsDetail () {
            await getPresellGoodDetail({
                memberCode: (this.userInfo && this.userInfo.companyCode) || '',
                presaleId: this.presaleId,
                skuId: this.skuId
            }).then((data) => {
                if (!data.data) {
                    Toast('页面内容不存在，请返回重试')
                    return
                }
                let presellData = data.data
                this.goodShow = true
                if (!presellData) {
                    return false
                }
                presellData.quantity = 1
                if (presellData.spuDetailList) {
                    this.detail = presellData.spuDetailList
                }
                this.picUrl = presellData.imgUrlList[0]
                this.goods = presellData
                this.goodInfo = {
                    cardImage: this.picUrl,
                    cardHeader: presellData.skuName,
                    cardSubhead: '',
                    cardPrice: '¥????',
                    cardUrl: ''
                }
                this.timeString()
                this.getPresellSlider()
                this.getShopInfo()
                this.presellShow = true
            }, (err) => {
                if (err.response.status === 429) {
                    this.$router.push('/b2b/429')
                }
            })
        },
        async getPresellSlider () {
            const { data } = await presellSlider({
                presaleId: this.presaleId,
                skuId: this.skuId
            })
            if (!data) {
                return false
            }
            this.totalNum = data.reduce((acc, cur) => {
                return acc + cur.quantity
            }, 0)
            this.sliderData = data
        },
        onShareGoods () {
            let shareUrl = '/b2b/presellActivityList/goodDetail'
            let shareTitle = this.goods.skuName
            let content = '[正品行货]' + this.goods.skuName
            let imgLink = this.picUrl + '?x-oss-process=image/resize,w_400,h_400/quality,Q_100'
            let urlLink = shareUrl + '?presaleId=' + this.presaleId + '&skuId=' + this.skuId + '&isWeixin=true&type=4&invitationCode=' + this.invitationCode
            let miniprogramPath = '/goods/pages/presellActivity/presellGoodDetail/index?presaleId=' + this.presaleId + '&skuId=' + this.skuId + '&sourceUserId=' + this.userInfo.id
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'activityShare',
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'presaleId': this.presaleId,
                    'skuId': this.skuId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                })
            } else {
                window.kfxt.activityShare(shareTitle, content, imgLink,
                    urlLink,
                    this.presaleId,
                    this.skuId
                )
                window.kfxt.newActivityShare(JSON.stringify({
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'spikeId': this.spikeId,
                    'skuId': this.skuId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                }))
            }
        },
        async getInvitationCodeData () {
            const { data } = await getInvitationCode({
                userId: this.userInfo.id
            })
            this.invitationCode = data.merchantInvitationCode
        },
        // 店铺信息
        async getShopInfo () {
            const { data } = await shopInfo({
                merchantCode: this.goods.merchantCode
            })
            this.shopName = data.shopName
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.goodsDetailBack = localStorage.getItem('goodsDetailBack')
        this.getGoodsDetail()
        if (!this.$route.query.isWeixin) {
            this.getInvitationCodeData()
        }
    },
    beforeRouteEnter (to, from, next) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger' && to.query.isWeixin) {
            // 微信
            next(vm => {
                vm.showN = true
            })
        } else if (to.query.isWeixin) {
            // 判断原生
            // window.location.href = 'dfx://'
            setTimeout(function () {
                window.location.href = '/newshareh5/b2b/downdfx?presaleId=' + to.query.presaleId + '&skuId=' + to.query.skuId + '&type=' + to.query.type + '&invitationCode=' + to.query.invitationCode
            }, 500)
        } else {
            next(vm => {
                vm.showN = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.overblock{
    width: 396px;
    height: 184px;
    right: 48px;
    top: 20px;
    position: absolute;
}
.overlayClass{
    background: none;
    z-index: 100 !important;
}
.goods {
    font-size: 28px;
    padding-bottom: 150px;
    background: #f5f5f5;
    position: relative;
    width: 100%;
    .banner {
        height: 100vw;
        position: relative;
        .banner-item {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        color: #999999;
        span {
            vertical-align: top;
            margin-left: 12px;
            color: #000;
        }
        .item {
            float: right;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        img {
            width: 32px;
            height: 32px;
            vertical-align: text-top;
            position: relative;
            top: 4px;
            margin-right: 8px;
        }
    }
    .contentDetail {
        background: #ffffff;
        .demo-item {
            min-height: 200px;
            box-sizing: border-box;
        }
        .cont {
            padding: 32px;
            z-index: 99;
            .btn {
                float: right;
                width: 208px;
                height: 64px;
                line-height: 64px;
                font-size: 28px;
                text-align: center;
                border-radius: 64px;
                color: #ffffff;
                background: #ff4d4f;
                &.active {
                    background: #ccc;
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        box-shadow: 0px 0px 0px 0px #D8D8D8;
        padding: 24px 32px;
        z-index: 9;
        .btn {
            width: 100%;
            height: 90px;
            line-height: 90px;
            font-size: 34px;
            text-align: center;
            border-radius: 80px;
            color: #ffffff;
            background: #ff4d4f;
            &.active {
                pointer-events: none;
                cursor: default;
                opacity: 0.6;
            }
        }
    }
}
.select {
    padding: 24px;
    background: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .head {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 40px;
        .img {
            width: 220px;
            height: 220px;
            flex: 0 0 220px;
            background: #999999;
            img {
                display: inline-block;
                width: 100%;
                height: 100%;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        .title2 {
            margin-left: 24px;
            flex: 0 0 460px;
            display: flex;
            align-content: space-between;
            flex-wrap: wrap;
            .close {
                flex: 0 0 100%;
                overflow: hidden;
                img {
                    width: 48px;
                    height: 48px;
                    float: right;
                }
            }
            .img {
                width: 220px;
                height: 220px;
                flex: 0 0 220px;
                background: #999999;
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    margin: 0 auto;
                    background: #f2f3f5;
                    object-fit: cover;
                }
            }
            .goodsBt {
                .price {
                    flex: 0 0 100%;
                    font-size: 28px;
                    color: #ff7a45;
                    height: 48px;
                    font-family: PingFangSC;
                    sub {
                        font-size: 22px;
                    }
                    span {
                        font-size: 24px;
                        color: #999999;
                        margin-left: 32px;
                        text-decoration: line-through;
                        sub {
                            font-size: 16px;
                        }
                    }
                }
                .cont {
                    font-size: 24px;
                    color: #333333;
                    line-height: 36px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .gg {
                    font-size: 24px;
                    line-height: 30px;
                    height: 60px;
                    width: 360px;
                    margin-top: 12px;
                    color: #666666;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                }
            }
        }
    }
}
.nums {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
    line-height: 60px;
    .cartN {
        flex: 0 0 400px;
        position: relative;
        .xg {
            position: absolute;
            left: 60px;
            color: #ff7a45;
            font-size: 24px;
        }
    }
    .cartClass{
        float: right;
    }
    .num {
        display: flex;
        justify-content: flex-end;
        span {
            display: inline-block;
            width: 66px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            &.jian {
                background: url(../../../assets/img/b2b/btn_reduce@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jian2 {
                background: url(../../../assets/img/b2b/btn_reduce_pre@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jia {
                background: url(../../../assets/img/b2b/btn_add@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.w38 {
                width: 76px;
                font-size: 32px;
                background: #f5f5f5;
                margin: 0 2px;
            }
        }
    }
}
.fot {
    padding: 32px;
    background: #ffffff;
    .btn {
        display: flex;
        justify-content: space-between;
        .btn1 {
            width: 100%;
            height: 90px;
            line-height: 90px;
            font-size: 34px;
            text-align: center;
            border-radius: 80px;
            color: #ffffff;
            background: #ff4d4f;
            &.btnBg {
                background: #ff7a45;
                color: #ffffff;
            }
            &.btnRed {
                background: #ff4d4f;
                color: #ffffff;
            }
            &.oss2 {
                border: 0.026667rem solid #ccc;
                color: #fff;
                background: #ccc;
                width: 100%;
            }
        }
    }
}

.nums {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
    line-height: 60px;
    .cartN {
        flex: 0 0 400px;
        position: relative;
        .xg {
            position: absolute;
            left: 60px;
            color: #ff7a45;
            font-size: 24px;
        }
    }
    .cartClass{
        float: right;
    }
    .num {
        display: flex;
        justify-content: flex-end;
        span {
            display: inline-block;
            width: 66px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            &.jian {
                background: url(../../../assets/img/b2b/btn_reduce@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jian2 {
                background: url(../../../assets/img/b2b/btn_reduce_pre@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.jia {
                background: url(../../../assets/img/b2b/btn_add@2x.png)
                    no-repeat;
                background-size: 100% 100%;
            }
            &.w38 {
                width: 76px;
                font-size: 32px;
                background: #f5f5f5;
                margin: 0 2px;
            }
        }
    }
}
.notice-swipe {
    height: 80px;
    line-height: 80px;
}

/deep/ .van-notice-bar, /deep/ .van-notice-bar__wrap{
    height: 80px;
    font-size: 28px;
}

/deep/ .van-notice-bar__content{
    width: 100%;
    text-align: right;
}

/deep/ .van-tabs--line .van-tabs__wrap, /deep/ .van-tab{
    height: 80px;
    line-height: 80px;
    font-size: 28px;
}
/deep/ .van-stepper__minus{
    width: 56px;
    height: 56px;
    padding: 8px;
}
/deep/ .van-stepper__plus{
    width: 56px;
    height: 56px;
    padding: 8px;
}
/deep/ .van-stepper__minus::before{
    width: 26px;
    height: 3px;
}
/deep/ .van-stepper__plus::before{
    width: 26px;
    height: 3px;
}
/deep/ .van-stepper__plus::after{
    width: 3px;
    height: 26px;
}
/deep/ .van-stepper__input{
    width: 64px;
    font-size: 28px;
    height: 56px;
    margin: 0 4px;
    color: #323232;
}
/deep/ .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #ccc;
}
/deep/ .van-tabs__line {
    background: none;
}
</style>
